<template>


  <b-col lg="12" class="py-2 mx-0">
    <b-row align-h="center">
      <b-col lg="6" class="text-center">
        <m-a :href="{ name: 'Home'}">
          <img id="logo" :alt='findAttributeOnSiteInfo("site_name")[0]' :src='findAttributeOnSiteInfo("icon")[0]'/>
        </m-a>
      </b-col>
      <div class="main-menu text-center my-auto col-lg-6">
        <b-button variant="transparent" class=" dashboard-icon" pill v-b-toggle.sidebar>منو</b-button>

        <m-search-input-1 class="d-inline search-input-1-button"/>

        <router-link class="mr-2" v-if="isAuth  || findAttributeOnSiteInfo('cartType') == 1"
                     :to="{ name: 'ShoppingCart'}">
          <b-button variant="transparent" class="dashboard-icon" pill>
            <b-icon icon="cart"/>
          </b-button>
        </router-link>

        <router-link class="mr-2" v-else :to="{ name: 'UnAuthenticatedShoppingCart' }">
          <b-button variant="transparent" class="dashboard-icon" pill>
            <b-icon icon="cart"/>
          </b-button>
        </router-link>

        <router-link class="mr-2" :to="{ name: 'Dashboard'}" v-if="isAuth">
          <b-button variant="transparent" class="dashboard-icon" pill>
            <b-icon icon="person-fill"/>
          </b-button>
        </router-link>

        <router-link class="mr-2" :to="{ name: 'Login'}" v-else>
          <b-button variant="transparent" class="dashboard-icon" pill>
            <b-icon icon="person-fill"/>
          </b-button>
        </router-link>
        <b-sidebar ref="sidebar" id="sidebar" backdrop shadow="">
          <div class="menu-list px-3 py-2 d-flex align-items-center">


            <div class="text-center" v-for="menu in storeMenus" :key="menu.id"
                 v-if="menu.position === 'store_nav'">
              <NavMenuItem v-for="item in menu.children" :item="item" :key="item.id"/>
            </div>

          </div>
        </b-sidebar>
      </div>
    </b-row>
  </b-col>


</template>

<script>
import {mapGetters} from "vuex";
import NavMenuItem from './NavMenuItem'

export default {
  name: "Nav301",
  components: {NavMenuItem},
  computed: {
    ...mapGetters({
      isAuth: "User/isAuthenticated",
      storeMenus: "Menu/getStoreMenus",
    }),
  },
}
</script>

<style>

.search-input-1-button .search-input-1 .search-input-1-icon {
  color: white !important;
  fill: white !important;
}

.search-input-1-button .search-input-1 {
  background: var(--primary) !important;
  border-radius: 20px;
}
</style>

<style scoped>
.main-menu {
  background-color: transparent !important;
}

.menu-list {
  color: var(--primary);
  flex-direction: column;
  height: 100%;
}

header {
  height: 200px;
  background-color: var(--primary);
  background-size: 100%;
  padding: 0;
  margin: 0;
}

#logo {
  width: 75px;
}

.dashboard-icon {
  color: white !important;
  fill: white !important;
  background: var(--primary) !important;
}

</style>